import { UndoManager } from 'loro-crdt';
/**
 * Local undo/redo over Loro's `UndoManager`.
 *
 * Bound to the document's peer, so it undoes **this peer's commits only**. On the
 * room Durable Object that means the agent's own edits (e.g. an accepted
 * suggestion or a programmatic insert) — not remote clients' edits. Each client
 * runs its own `UndoManager` for its own edits.
 */
export class Undo {
    manager;
    /** @param options - Document and optional Loro undo configuration. */
    constructor(options) {
        this.manager = new UndoManager(options.doc, options.config ?? {});
    }
    /**
     * Undoes this peer's last commit.
     *
     * @returns Whether an operation was applied.
     */
    undo() {
        return this.manager.undo();
    }
    /**
     * Redoes this peer's last undone commit.
     *
     * @returns Whether an operation was applied.
     */
    redo() {
        return this.manager.redo();
    }
    /**
     * Checks undo availability.
     *
     * @returns Whether an undo operation is available.
     */
    canUndo() {
        return this.manager.canUndo();
    }
    /**
     * Checks redo availability.
     *
     * @returns Whether a redo operation is available.
     */
    canRedo() {
        return this.manager.canRedo();
    }
    /**
     * The underlying Loro manager, for editors that own their own undo binding.
     *
     * A second `UndoManager` on the same document tracks the same edits but
     * keeps its own cursor into them: once this one undoes, the other still
     * reports `canUndo()` while its `undo()` does nothing. Sharing this avoids
     * an undo button that looks live and is not.
     */
    get raw() {
        return this.manager;
    }
}
//# sourceMappingURL=undo.js.map